// extracted by mini-css-extract-plugin
export default {"greyText":"l0M6swYyUoGM7g5BGUnY"};